import Constants from "./constants";
import CookieManager from "./CookieManager";
import Helper from "./helper";
import axios from "axios";


const loadHarvestData_old = async(req, retries = 0) => {
  const profileData = CookieManager.getCookie("user-data")?.length
    ? JSON.parse(CookieManager.getCookie("user-data"))
    : null;
  const userId = profileData?.email?.length > 0 ? Helper.encode(profileData.email) : Helper.encode(Constants.H_DEFAULT_USER_ID);
    
  //load token 
  const serviceToken = CookieManager.getCookie("service-token");
  const memberData = CookieManager.getCookie("member-data")?.length
    ? JSON.parse(CookieManager.getCookie("member-data"))
    : null;
  if(!(serviceToken?.length > 0) || !memberData){
    const authData = await refreshToken(userId);
    if(authData){
      req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
      req.token = authData.serviceToken;
    }else{
      console.log("Token data loading error : ")
      return;
    } 
  }else{
    req.url = req.refUrl?.replace("{memberToken}", memberData?.MemberToken?.Value);
    req.token = serviceToken;
  }
  return await loadLibraryData(req).then(async res => {
    if(res?.data?.Error?.Code === "21" || res?.data?.Error?.Code === "3"){
      return await refreshToken(userId).then(async(authData) =>{
        if(authData){
          req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
          req.token = authData.serviceToken;
          retries++;
          return loadHarvestData(req, retries);
        }else{
          console.log("Token data loading error : ")
          return;
        }
      }).catch(err => {
        throw err;
      });
    }
    return res?.data;
  }).catch(async(err) => {
    if(err?.response?.status === 400 && err?.response?.statusText === "invalid_token" && retries < 3){
      return await refreshToken(userId).then(async(authData) =>{
        if(authData){
          req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
          req.token = authData.serviceToken;
          retries++;
          return loadHarvestData(req, retries);
        }else{
          console.log("Token data loading error : ")
          return;
        }
      }).catch(err => {
        throw err;
      });
    }else{
      throw err;
    }    
  })
}

const loadHarvestData = async(req, retries = 0) => {
  const profileData = CookieManager.getCookie("user-data")?.length
    ? JSON.parse(CookieManager.getCookie("user-data"))
    : null;
  const userId = profileData?.email?.length > 0 ? Helper.encode(profileData.email) : Helper.encode(Constants.H_DEFAULT_USER_ID);
    
  //load token 
  const serviceToken = CookieManager.getCookie("service-token");
  const memberData = CookieManager.getCookie("member-data")?.length
    ? JSON.parse(CookieManager.getCookie("member-data"))
    : null;
  if(!(serviceToken?.length > 0) || !memberData){
    const authData = await refreshToken(userId);
    if(authData){
      req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
      req.token = authData.serviceToken;
    }else{
      console.log("Token data loading error : ")
      return;
    } 
  }else{
    req.url = req.refUrl?.replace("{memberToken}", memberData?.MemberToken?.Value);
    req.token = serviceToken;
  }
  return await getDataFromHarvest(req).then(async res => {
    if(res?.data?.Error?.Code === "21" || res?.data?.Error?.Code === "3"){
      return await refreshToken(userId).then(async(authData) =>{
        if(authData){
          req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
          req.token = authData.serviceToken;
          retries++;
          return loadHarvestData(req, retries);
        }else{
          console.log("Token data loading error : ")
          return;
        }
      }).catch(err => {
        throw err;
      });
    }
    return res?.data;
  }).catch(async(err) => {
    if(err?.response?.status === 400 && err?.response?.statusText === "invalid_token" && retries < 3){
      return await refreshToken(userId).then(async(authData) =>{
        if(authData){
          req.url = req.refUrl?.replace("{memberToken}", authData.memberData?.MemberToken?.Value);
          req.token = authData.serviceToken;
          retries++;
          return loadHarvestData(req, retries);
        }else{
          console.log("Token data loading error : ")
          return;
        }
      }).catch(err => {
        throw err;
      });
    }else{
      throw err;
    }    
  })
}

const loadPublicHarvestData = async(req) => {
  return await loadLibraryData(req, true).then(async res => {
    if(res?.data?.Error){
      throw res.data.Error;
    }
    return res?.data;
  }).catch((err) => {
    throw err;    
  })
}

const refreshToken = async(userId) => {
  return await axios({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}api/users/refresh-token/${userId}`,
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,

    }).then(resp => {
      if(resp.status === 200 && resp.data.success){
        CookieManager.setCookie("member-data", JSON.stringify(resp?.data?.data?.memberData));
        CookieManager.setCookie("service-token", resp?.data?.data?.serviceToken);
        return resp.data.data;
      }else{
        console.log("RefreshTokenLoadingError : ", resp);
      }

    })
    .catch(err => {
        console.log("RefreshTokenExecutionError : ", err);
      throw err;
    });
}
const loadLibraryData = async(reqObj, publicReq = false) =>{
  const url = publicReq ? `${process.env.REACT_APP_BASE_URL}api/library/public` : `${process.env.REACT_APP_BASE_URL}api/library`;
  return await axios({
    method: "post",
    url: url,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    data : reqObj,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,

  }).then(resp => {
      // console.log("LibraryLoadRequestExecutionResponse : ", resp);
    return resp.data ? resp.data : resp;
  })
  .catch(err => {
      console.log("LibraryLoadRequestExecutionError : ", err);
    throw err;
  });
}

const getDataFromHarvest = async(reqObj, publicReq = false) =>{
  return await axios({
    method: reqObj.method,
    url: "https://service.harvestmedia.net/HMP-WS.svc" + reqObj.url,
    headers: {
        'Authorization': reqObj.token,
        'Accept' : 'application/json',
        'Content-Type': 'application/json'
      },
    data : reqObj.data,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,

  }).then(resp => {
      // console.log("Harvest DataLoadRequestExecutionResponse : ", resp);
    return resp;
  })
  .catch(err => {
      console.log("LibraryLoadRequestExecutionError : ", err);
    throw err;
  });
}


const executeRequest = async (req) => {
  const URL = Constants.H_BASE_URL + req.url;
  let headers = null;
  if(req?.headers){
    headers = req.headers
  }else{
    headers = {
      "Accept" : "application/json",
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    }
  }
  headers["Authorization"] = req.token;

  return await axios({
    method: req.method,
    url: URL,
    headers: headers,
    data : req.data,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,

  }).then(resp => {
      // console.log("HarvestRequestExecutionResponse : ", resp);
    return resp.data ? resp.data : resp;
  })
  .catch(err => {
      console.log("HarvestRequestExecutionError : ", err);
    throw err;
  });
}

  
const HarvestService = { loadHarvestData, refreshToken, loadPublicHarvestData }

export default HarvestService;